<!--/******************************************************************
* @NAME ChenJi
* @CREATEDATE 2022/4/8
* @DESC <模态框>
* ****************************************************************/-->
<template>
  <transition name="modal">
    <div class="utm-modal" v-if="utmModal">
      <div class="utm-modal-mask"></div>
      <div class="utm-modal-wrap">
        <div class="utm-modal-box" :style="{width:width, top: top,height:height}">
          <div class="utm-modal-content">
            <!--关闭按钮-->
            <span class="utm-modal-close" @click="closeModal">
              <i class="ivu-icon ivu-icon-ios-close"></i>
            </span>
            <!--顶部标题-->
            <div class="utm-modal-header">
              <slot name="header" v-if="title">
                {{title}}
              </slot>
              <slot name="header" v-else>
                <i class="utm-font utm-icon-warning" style="color: rgba(205,71,70,1)"></i>
                Confirm To Delete {{dataType}}?
              </slot>
            </div>
            <!--内容-->
            <div class="utm-modal-body">
              <div class="utm-modal-center">
                <slot name="main">
                  <!-- Caution! There are linked data to this field. By deleting this item, the linked data will be affected and not able to recover. Please confirm if you are still sure to delete. -->
                  <div class="utm-modal-tip">
                    <span class="delete-office-icon">
                      <psim-icon type="utm-font utm-tip-icon" size="36" color="#F66F6A"></psim-icon>
                    </span>
                    <span class="utm-modal-desc">The data will be deleted and not able to recover. Press 'Confirm' to proceed.</span>
                  </div>
                </slot>
              </div>
            </div>
            <!--底部按钮-->
            <div class="utm-modal-footer">
              <slot name="footer">
                <!--默认为确认/删除-->
                <button type="button" class="utm-btn utm-red-bg utm-default-btn" @click="confirm">Confirm</button>
                <button type="button" class="utm-btn utm-blue-line-btn utm-default-btn" @click="closeModal">Cancel</button>
              </slot>
            </div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
    export default {
      name: "utm-modal",
      props:{
        utmModal:{
          type:Boolean,
          default:false
        },
        width:{
          type:String,
          default:'900px',
        },
        title:{
          type:String,
          default:'',
        },
        dataType:{
          type:String,
          default:''
        },
        // 距离顶部的距离
        top: {
          type: String,
          default: '100px'
        },
        height:{
          type:String
        }
      },
      methods:{
        // 弹框关闭
        closeModal:function () {
          this.$emit('closeModal');
        },
        // 确认
        confirm:function () {
          this.$emit('confirm');
        },
      }
    }
</script>
<style>
  .utm-modal-center .utm-modal-tip {
    text-align: center;
  }
  .utm-modal-center .utm-modal-icon{
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 56px;
    height: 56px;
    margin: 16px 0;
    border-radius: 28px;
    background: rgba(var(--main-color-rgb), .15);
  }
  .utm-modal-center .utm-modal-desc {
    display: block;
    padding: 24px;
    color: #2F3234;
    font-size: 18px;
  }
</style>
<style scoped>
.utm-modal-center .delete-office-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 56px;
  height: 56px;
  margin: 16px 0;
  border-radius: 28px;
  background: rgba(246,111,106,.15);
}
</style>



// WEBPACK FOOTER //
// src/admin/components/commonComponents/utmModal.vue